import type { SVGProps } from 'react';

export default function QuestionMarkCircle(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="7.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10.7111 8.97641C11.5019 8.28445 12.7841 8.28445 13.5749 8.97641C14.3658 9.66837 14.3658 10.7903 13.5749 11.4822C13.4373 11.6027 13.2848 11.7021 13.1225 11.7806C12.6192 12.0242 12.143 12.4545 12.143 13.0137V13.5199M12.1429 15.5449H12.1479V15.55H12.1429V15.5449Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
